document.addEventListener('DOMContentLoaded', () => {
  const slider = document.getElementById('joozSlider');
  const next = document.querySelector('.jooz-arrow.right');
  const prev = document.querySelector('.jooz-arrow.left');

  if (!slider) return;

  let originalCards = Array.from(slider.querySelectorAll('.jooz-card'));
  if (!originalCards.length) return;

  let visibleCards = getVisibleCards();
  let index = visibleCards;
  let autoScroll;

  function getVisibleCards() {
    if (window.innerWidth <= 600) return 1;
    if (window.innerWidth <= 992) return 2;
    return 4;
  }

  function getCardWidth() {
    const card = slider.querySelector('.jooz-card');
    const style = getComputedStyle(card);
    return card.offsetWidth + parseInt(style.marginRight);
  }

  function build() {
    stop();
    slider.innerHTML = '';
    visibleCards = getVisibleCards();
    index = visibleCards;

    // prepend last
    originalCards.slice(-visibleCards).forEach(card =>
      slider.appendChild(card.cloneNode(true))
    );

    // originals
    originalCards.forEach(card => slider.appendChild(card));

    // append first
    originalCards.slice(0, visibleCards).forEach(card =>
      slider.appendChild(card.cloneNode(true))
    );

    slider.scrollLeft = getCardWidth() * visibleCards;
    start();
  }

  function moveNext() {
    index++;
    slider.scrollTo({
      left: getCardWidth() * index,
      behavior: 'smooth'
    });

    if (index >= originalCards.length + visibleCards) {
      setTimeout(() => {
        index = visibleCards;
        slider.scrollLeft = getCardWidth() * visibleCards;
      }, 300);
    }
  }

  function movePrev() {
    if (index <= visibleCards) return; // ⛔ never go left unsafe

    index--;
    slider.scrollTo({
      left: getCardWidth() * index,
      behavior: 'smooth'
    });
  }

  function start() {
    autoScroll = setInterval(moveNext, 5000);
  }

  function stop() {
    clearInterval(autoScroll);
  }

  function reset(fn) {
    stop();
    fn();
    start();
  }

  next && (next.onclick = () => reset(moveNext));
  prev && (prev.onclick = () => reset(movePrev));

  slider.addEventListener('mouseenter', stop);
  slider.addEventListener('mouseleave', start);

  [next, prev].forEach(btn => {
    if (!btn) return;
    btn.addEventListener('mouseenter', stop);
    btn.addEventListener('mouseleave', start);
  });

  window.addEventListener('resize', () => {
    clearTimeout(window.__rz);
    window.__rz = setTimeout(build, 300);
  });

  build();
});



/** start slider top */

document.addEventListener('DOMContentLoaded', () => {
  const slider = document.getElementById('joozSlider_range');
  const next = document.querySelector('.jooz-arrow.right');
  const prev = document.querySelector('.jooz-arrow.left');

  if (!slider) return;

  let originalCards = Array.from(slider.querySelectorAll('.jooz-card_img'));
  if (!originalCards.length) return;

  let autoScroll;
  let visibleCards = getVisibleCards();
  let index = visibleCards;

  function getVisibleCards() {
    if (window.innerWidth <= 600) return 1;
    if (window.innerWidth <= 992) return 2;
    return 5; // ⭐ desktop
  }

  function getCardWidth() {
    const card = slider.querySelector('.jooz-card_img');
    const style = getComputedStyle(card);
    return card.offsetWidth + parseInt(style.marginRight || 0);
  }

  function build() {
    stop();
    slider.innerHTML = '';

    visibleCards = getVisibleCards();
    index = visibleCards;

    originalCards.slice(-visibleCards).forEach(card =>
      slider.appendChild(card.cloneNode(true))
    );

    originalCards.forEach(card => slider.appendChild(card));

    originalCards.slice(0, visibleCards).forEach(card =>
      slider.appendChild(card.cloneNode(true))
    );

    slider.scrollLeft = getCardWidth() * visibleCards;
    start();
  }

  function moveNext() {
    index++;
    slider.scrollTo({
      left: getCardWidth() * index,
      behavior: 'smooth'
    });

    if (index >= originalCards.length + visibleCards) {
      setTimeout(() => {
        index = visibleCards;
        slider.scrollLeft = getCardWidth() * visibleCards;
      }, 300);
    }
  }

  function movePrev() {
    if (index <= visibleCards) return;
    index--;
    slider.scrollTo({
      left: getCardWidth() * index,
      behavior: 'smooth'
    });
  }

  function start() {
    autoScroll = setInterval(moveNext, 2000);
  }

  function stop() {
    clearInterval(autoScroll);
  }

  function reset(fn) {
    stop();
    fn();
    start();
  }

  next && (next.onclick = () => reset(moveNext));
  prev && (prev.onclick = () => reset(movePrev));

  /* ✅ HOVER PAUSE */
  slider.addEventListener('mouseenter', stop);
  slider.addEventListener('mouseleave', start);

  [next, prev].forEach(btn => {
    if (!btn) return;
    btn.addEventListener('mouseenter', stop);
    btn.addEventListener('mouseleave', start);
  });

  window.addEventListener('resize', () => {
    clearTimeout(window.__resizeTimer);
    window.__resizeTimer = setTimeout(build, 300);
  });

  build();
});


/*** End Slider Top */


/*** mapper js */

document.addEventListener('DOMContentLoaded', function () {

  /* ========== SAFETY CHECKS ========== */
  if (typeof L === 'undefined') {
    console.warn('Leaflet not loaded');
    return;
  }

  const mapEl = document.getElementById('map');
  if (!mapEl) {
    console.warn('Map container not found');
    return;
  }

  /* ========== MAP INIT ========== */
  const map = L.map('map').setView([-1.286389, 36.817223], 6);

  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '© OpenStreetMap'
  }).addTo(map);

  const allMarkers = L.featureGroup().addTo(map);

  /* ========== MAIN STORES (WITH data-lat/lng) ========== */
  document.querySelectorAll('.store-item[data-lat][data-lng]').forEach(store => {
    const lat = parseFloat(store.dataset.lat);
    const lng = parseFloat(store.dataset.lng);
    const name = store.querySelector('h4')?.innerText?.trim();

    if (!lat || !lng || !name) return;

    const marker = L.marker([lat, lng]).bindPopup(name);
    allMarkers.addLayer(marker);

    const btn = store.querySelector('.view-map');
    if (btn) {
      btn.addEventListener('click', () => {
        map.setView([lat, lng], 15);
        marker.openPopup();
      });
    }
  });

  /* ========== VERIFIED SUB-LOCATIONS ONLY ========== */
  document.querySelectorAll('.store-child.verified[data-lat][data-lng]').forEach(child => {
    const lat = parseFloat(child.dataset.lat);
    const lng = parseFloat(child.dataset.lng);
    const name = child.querySelector('span')?.innerText?.trim();

    if (!lat || !lng || !name) return;

    const marker = L.marker([lat, lng]).bindPopup(name);
    allMarkers.addLayer(marker);

    const btn = child.querySelector('.view-child-map');
    if (btn) {
      btn.addEventListener('click', () => {
        map.setView([lat, lng], 15);
        marker.openPopup();
      });
    }
  });

  /* ========== AUTO FIT ALL MARKERS ========== */
  if (allMarkers.getLayers().length > 0) {
    map.fitBounds(allMarkers.getBounds(), {
      padding: [40, 40]
    });
  }

});

